/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


//= require selectize.min
window.VendorTemplates = {
  _addRowAndToggleButtons(event) {
    $('.vendor-template-form:not(.hide) .link-to-add').click();
    const $target = $(event.target);
    const $row = $target.parents('tr');
    $row.find('.add-row').toggleClass('hidden');
    $row.find('.remove-row').toggleClass('hidden');
    $row.find('a.remove_nested_fields').removeClass('hidden');
    return $row.addClass('added').removeClass('selected');
  },

  _enableButton(event) {
    return setTimeout(() => $('input[type="submit"]').prop('disabled', false).val(I18n.t('v4.company_settings.templates.vendor_templates.new.save_template'))
    , 500);
  },

  _disableInputsFor(element) {
    return $(element).find(":input").prop('disabled', true);
  },

  _findEmptyInputs(element) {
    return _.reject(element.find(':input'), input => (input.value !== '') || ($(input).hasClass('file')));
  },

  _markErrors(element) {
    return _.each(this._findEmptyInputs(element), input => $(input).closest('td').addClass('error'));
  },

  _isFilled(row) {
    row = $(row);

    if (row.hasClass('new')) {
      const emptyInputs = this._findEmptyInputs(row);
      if (emptyInputs.length === 2) {
        this._disableInputsFor(row);
        return true;
      } else if (emptyInputs.length === 0) {
        return true;
      } else {
        this._markErrors(row);
        this._enableButton();
        return false;
      }
    } else {
      if (this._findEmptyInputs(row).length > 0) {
        this._markErrors(row);
        this._enableButton();
        return false;
      } else {
        return true;
      }
    }
  },

  _enableSubmit() {
    $('td').removeClass('error');
    $('small.error').remove();
    const $rows = $('.vendor-template-form tr.fields');
    if (_.every($rows, row => this._findEmptyInputs($(row)).length === 2) && $rows.hasClass('new')) {
      this._markErrors($rows);
      this._enableButton();
      return this._findEmptyInputs($rows).length === 0;
    } else {
      return _.reject($rows, _.bind(this._isFilled, this)).length === 0;
    }
  },

  _fireFileUpload() {
    return $(this).parent().find('input').click();
  },

  _changeFileName(e) {
    return $(this).parents('td').find('.name-placeholder').text(e.target.files[0].name);
  },

  initialize() {
    $(document).on('click', '.add-row', _.bind(this._addRowAndToggleButtons, this));
    $(document).on('submit', 'form', _.bind(this._enableSubmit, this));
    $(document).on('click', '.add-document-button', this._fireFileUpload);
    $(document).on('change', 'input[type="file"]', this._changeFileName);
    return $('.link-to-add').click();
  }
};
